import { Injectable } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { AppAbility } from "../../util/service/auth.service";
import { Observable } from "rxjs";
import { EntityTyp } from "../../util/enums/entity-typ.enum";
import { BaseFormGroupService } from "../../util/components/modal/base-form-group.service";
import { EmployeeDto } from "app/api/models";
import { EmployeeService } from "app/api/services";
import { CaslAction } from "app/server/enums/casl-action.enum";

@Injectable({
  providedIn: "root",
})
export class EmployeeFormGroupService extends BaseFormGroupService<EmployeeDto> {
  entitySingular = "Betreuer:in";

  constructor(
    private fb: FormBuilder,
    public override modal: NgbActiveModal,
    protected toastr: ToastrService,
    private employeeService: EmployeeService,
    private ability: AppAbility
  ) {
    super(modal, toastr);
  }

  initFormGroup() {
    this.formGroup = this.fb.group({
      firstName: ["", [Validators.required]],
      lastName: ["", [Validators.required]],
      email: ["", [Validators.email]],
      phone: [""],
      officeIds: [[], Validators.required],
      version: [0, [Validators.required]],
    });

    this.setPermissions();
  }

  protected create(mergedEntity: EmployeeDto): Observable<EmployeeDto> {
    return this.employeeService.employeeControllerCreate({ body: mergedEntity });
  }

  protected update(mergedEntity: EmployeeDto): Observable<EmployeeDto> {
    return this.employeeService.employeeControllerUpdate({
      body: mergedEntity,
    });
  }

  protected reloadEntity(id: number): Observable<EmployeeDto> {
    return this.employeeService.employeeControllerFindOne({ id });
  }

  protected updateFormGroup(entity: EmployeeDto) {
    this.formGroup.patchValue(entity, { emitEvent: false });
    this.setPermissions();
  }

  private setPermissions() {
    if (this.ability.can(CaslAction.Update, EntityTyp.Employee)) {
      return;
    }
    this.formGroup.disable({ emitEvent: false });
  }
}
